import React from 'react';
import {
  ButtonContainer,
  InfoTitleContainer,
  MessageContainer,
  ResetButtonContainer,
  SimulatorDataContainer,
  SimulatorInfosContainer,
  SimulatorTitle,
  SimulatorWrapper,
} from './missedStandardSimulator.styled';
import { Body5, Headline5, Headline7 } from '../../../common/typography';
import Donut from 'lqa-ui/lib/Components/Donut';
import Refresh from '../../../common/icons/Refresh';
import { SimulateButtons } from '../SimulateButtons';
import { IMissedStandardSimulator } from '../../../../app/@types/missedStandardSimulator';
import { useTranslation } from 'react-i18next';
import { ButtonMedium } from '../../../../app/common/sharedComponents/buttons/ButtonMedium';

export function MissedStandardSimulator ({
  handleSimulateButtonClick,
  handleResetButtonClick,
  percentage,
  intent,
  change,
  changeIntent,
  simulateButtonList,
}: IMissedStandardSimulator) {
  const { t } = useTranslation();
  return (
    <>
      <SimulatorWrapper>
        <SimulatorTitle>
          <Headline5>
            {t('COMMON.DASHBOARD.MISSED_STANDARD_SIMULATOR')}
          </Headline5>
        </SimulatorTitle>
        <ButtonContainer>
          <SimulateButtons
            simulateButtonList={simulateButtonList}
            handleSimulateButtonClick={handleSimulateButtonClick}
          />
        </ButtonContainer>
        <SimulatorDataContainer>
          <Donut
            percentage={percentage}
            size={90}
            intent={intent}
            decimals={1}
            percentageSign={true}
            change={change}
            changeIntent={changeIntent}
          />
          <SimulatorInfosContainer>
            <InfoTitleContainer>
              <Headline7 color="eerieBlack">
                {t('COMMON.DASHBOARD.SIMULATE_SCORE')}
              </Headline7>
            </InfoTitleContainer>
            <MessageContainer>
              <Body5>{t('COMMON.DASHBOARD.SELECT_MISSED_STANDARD_TEXT')}</Body5>
            </MessageContainer>
            <ResetButtonContainer>
              <ButtonMedium
                title={t('COMMON.DASHBOARD.RESET_SCORE')}
                leftIcon={<Refresh />}
                onClick={handleResetButtonClick}
                backgroundColor="mint"
                textColor="battleShipGray"
              />
            </ResetButtonContainer>
          </SimulatorInfosContainer>
        </SimulatorDataContainer>
      </SimulatorWrapper>
    </>
  );
}
